import { useState, useEffect, Key } from 'react'
import './ExperienceCenter.scss'
import experienceCenterService from 'Services/experienceCenterService'
import { Link } from 'react-router-dom'
import { ModalWrapper, Pagination } from 'Components'
import SearchInput from 'Components/SearchInput/SearchInput'
import Swal from 'sweetalert2'
import { checkSearchInputType } from 'Helpers'

export interface experienceCenterType {
  id: string
  stationName: string
  product: string
  pumps: number
  dailySalesVolume: number
  stationAddress: string
  state: string
  latitude: number
  longitude: number
  rentage: number
  approvalStatus: string
  nextSubscriptionPaymentDueDate: string
  documents: ExperienceDocuments[]
  // statusHistory: [
  //   {
  //     status: string
  //     dateTimeInISO8601: string
  //     metadata: {
  //       deliveryTruckIds: string[]
  //       deliveryFee: number
  //       unitPrice: number
  //     }
  //     actor: string
  //   },
  // ]

  statusHistory: [
    {
      actor: string
      status: string
      dateTimeInISO8601: string
    },
  ]
  createdBy: string
  createdAt: string
  updatedAt: string
  customer: {
    userId: string
    firstName: string
    lastName: string
    msisdn: string
    accountId: string
  }
  rejectionReason: string
  approvalNotes: string
}

export interface ExperienceDocuments {
  keyFromCloudProvider: string
  url: string
  fileUuid: string
  mimetype: string
  fileCloudProvider: string
  fileCategory: string
  metadata: string
}

const ExperienceCenter = () => {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(1)
  const [pageTotal, setPageTotal] = useState(1)
  const [centers, setCenters] = useState<experienceCenterType[]>()

  const [status, setStatus] = useState('ALL')
  const [sortOrder, setSortOrder] = useState('DESC')

  const exCenter = async () => {
    await experienceCenterService.index(page, status, sortOrder).then((response) => {
      console.log({ response: response.data.data })
      const data = response.data.data
      setPage(data.pageNumber)
      setPageSize(data.pageSize)
      setPageTotal(data.total)
      setCenters(data.dataset)
    })
  }

  useEffect(() => {
    exCenter()
  }, [status, sortOrder, page])

  const searchRequest = (data: { firstName: string | undefined; lastName: string | undefined }) => {
    console.log(data)
  }

  const [searchOptionRequest, setSearchOptionRequest] = useState(false)

  const [searchReturnResult, setSearchReturnResult] = useState(false)

  const [centerSearching, setCenterSearching] = useState(false)

  const handleSearch = async (searchTermRaw: string) => {
    if (centerSearching) return

    setCenterSearching(true)
    setSearchReturnResult(false)

    const searchTerm = searchTermRaw.trim()
    const type = checkSearchInputType(searchTerm)

    if (searchTerm === '') {
      setCenterSearching(false)
      exCenter()
      return
    }

    let endpoint = ''

    if (type === 'PhoneNumber') {
      endpoint = `customerMsisdn=${encodeURIComponent(searchTerm)}`
    } else if (type === 'Numeric') {
      endpoint = `customerAccountId=${encodeURIComponent(searchTerm)}`
    } else if (type === 'name') {
      endpoint = `stationName=${encodeURIComponent(searchTerm)}`
    }

    if (!endpoint) {
      setCenterSearching(false)
      return
    }

    if (endpoint === '') {
      setCenterSearching(false)
      exCenter()
      return
    }

    await experienceCenterService.searchExperienceCenters(endpoint, page, sortOrder, status).then(
      (res) => {
        setPage(res.data.data.pageNumber)
        setPageSize(res.data.data.pageSize)
        setPageTotal(res.data.data.total)
        setCenters(res.data.data.dataset)
        setCenterSearching(false)
      },
      (error: { response: { data: { error: string } } }) => {
        setCenters([])

        setTimeout(() => {
          setCenterSearching(false)

          if (searchTerm.length < 9) {
            exCenter()
          }
        }, 3000)

        setCenterSearching(false)
        setSearchReturnResult(false)
      },
    )
  }

  const cancelSearch = () => {
    exCenter()
  }

  const [showModal, setShowModal] = useState(false)
  const [showApprovalModal, setShowApprovalModal] = useState(false)
  const [rejectionReason, serRejectionReason] = useState<string>('')
  const [approvalReason, serApprovalReason] = useState<string>('')
  const [ID, serID] = useState<string>('')

  const toggleModal = (id: string) => {
    setShowModal((prevState) => !prevState)
    serID(id)
  }

  const toggleAprovalModal = (id: string) => {
    setShowApprovalModal((prevState) => !prevState)
    serID(id)
  }

  const [approvalRequest, setApprovalRequest] = useState(false)

  const [rejectionRequest, setRejectionRequest] = useState(false)

  const reject = async () => {
    setRejectionRequest(true)
    if (!ID) return
    await experienceCenterService.reject({ rejectionReason }, ID).then(
      () => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Rejection Completed',
          showConfirmButton: false,
          timer: 2000,
        })

        setRejectionRequest(false)

        setTimeout(() => {
          exCenter()
          toggleModal(ID)
        }, 1000)
      },
      (error: { response: { data: { error: string } } }) => {
        setRejectionRequest(false)
        console.log('update Subscription error', error)

        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const approve = async () => {
    setApprovalRequest(true)
    if (!ID) return
    await experienceCenterService.approve({ approvalNotes: approvalReason }, ID).then(
      () => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          text: 'Rejection Completed',
          showConfirmButton: false,
          timer: 2000,
        })

        setApprovalRequest(false)

        setTimeout(() => {
          exCenter()
          toggleAprovalModal(ID)
        }, 1000)
      },
      (error: { response: { data: { error: string } } }) => {
        setApprovalRequest(false)
        console.log('update Subscription error', error)

        toggleAprovalModal(ID)
        Swal.fire({
          position: 'center',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  const exportExperienceCenters = async (docType: string) => {
    const a = document.createElement('a')
    a.style.display = 'none'
    document.body.appendChild(a)

    Swal.fire({
      text: 'Exporting, please wait a moment.',
      timer: 2000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await experienceCenterService.exportExperienceCenter(sortOrder, status).then(
      (response) => {
        const streamedData = new Blob([response.data], { type: docType })
        const streamedUrl = window.URL.createObjectURL(streamedData)

        a.href = streamedUrl
        a.download = 'experience_center.' + (docType === 'text/csv' ? 'csv' : 'doc')
        a.click()
        window.URL.revokeObjectURL(streamedUrl)
        Swal.close()
      },
      (error) => {
        Swal.close()
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 1500,
        })
      },
    )
  }

  return (
    <div className='ExperienceCenter'>
      <div className='card border-0 mt-3'>
        <div className='card-header border-0 px-0'>
          <div className='row mt-2'>
            <div className='col-12 col-md-8'>
              <SearchInput
                onSearch={handleSearch}
                placeholder={'Search by Station Name, Customer MSISDN or Customer ID'}
                searchRequest={searchRequest}
                searchOptionRequest={searchOptionRequest}
                searchReturnResult={searchReturnResult}
                cancelSearch={cancelSearch}
              ></SearchInput>
            </div>
            <div className='col-6 col-md-2 dropdown'>
              <button
                className='btn btn-filter dropdown-toggle'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                <svg
                  width='17'
                  height='17'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M10.94 22.65C10.46 22.65 9.99002 22.53 9.55002 22.29C8.67002 21.8 8.14002 20.91 8.14002 19.91V14.61C8.14002 14.11 7.81002 13.36 7.50002 12.98L3.76002 9.02001C3.13002 8.39001 2.65002 7.31001 2.65002 6.50001V4.20001C2.65002 2.60001 3.86002 1.35001 5.40002 1.35001H18.6C20.12 1.35001 21.35 2.58001 21.35 4.10001V6.30001C21.35 7.35001 20.72 8.54001 20.13 9.13001L15.8 12.96C15.38 13.31 15.05 14.08 15.05 14.7V19C15.05 19.89 14.49 20.92 13.79 21.34L12.41 22.23C11.96 22.51 11.45 22.65 10.94 22.65ZM5.40002 2.85001C4.70002 2.85001 4.15002 3.44001 4.15002 4.20001V6.50001C4.15002 6.87001 4.45002 7.59001 4.83002 7.97001L8.64002 11.98C9.15002 12.61 9.65002 13.66 9.65002 14.6V19.9C9.65002 20.55 10.1 20.87 10.29 20.97C10.71 21.2 11.22 21.2 11.61 20.96L13 20.07C13.28 19.9 13.56 19.36 13.56 19V14.7C13.56 13.63 14.08 12.45 14.83 11.82L19.11 8.03001C19.45 7.69001 19.86 6.88001 19.86 6.29001V4.10001C19.86 3.41001 19.3 2.85001 18.61 2.85001H5.40002Z'
                    fill='#868484'
                  />
                  <path
                    d='M6.00004 10.75C5.86004 10.75 5.73004 10.71 5.60004 10.64C5.25004 10.42 5.14004 9.94999 5.36004 9.59999L10.29 1.69999C10.51 1.34999 10.97 1.23999 11.32 1.45999C11.67 1.67999 11.78 2.13999 11.56 2.48999L6.63004 10.39C6.49004 10.62 6.25004 10.75 6.00004 10.75Z'
                    fill='#868484'
                  />
                </svg>
                Filters
              </button>
              <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
                <div className='dropdown-item'>
                  <form action=''>
                    <div className='form-group'>
                      <label htmlFor=''>Sort List</label>
                      <select
                        id=''
                        className='form-control'
                        onChange={(e) => {
                          setSortOrder(e.target.value)
                        }}
                      >
                        <option value='DESC'>Descending Order</option>
                        <option value='ASC'>Ascending Order</option>
                      </select>
                    </div>

                    <div className='form-group mt-3'>
                      <label htmlFor=''>Status</label>
                      <select
                        id=''
                        className='form-control'
                        onChange={(e) => {
                          setStatus(e.target.value)
                        }}
                      >
                        <option value='ALL'>All</option>
                        <option value='PENDING_APPROVAL'>Pending Approval</option>
                        <option value='APPROVED'>Approved</option>
                        <option value='REJECTED'>Rejected</option>
                        <option value='INSTALLATION_COMPLETED'>Installation Completed</option>
                        <option value='DECOMMISSIONED'>Decommissioned</option>
                      </select>
                    </div>
                    <div className='row mt-3'>
                      <div className='col-md-6'>
                        <button
                          type='button'
                          className='btn btn-reset'
                          onClick={() => {
                            setSortOrder('DESC')
                            setStatus('ALL')
                          }}
                        >
                          Reset
                        </button>
                      </div>
                      <div className='col-md-6 text-end'>
                        <button
                          type='button'
                          className='btn btn-filter'
                          onClick={() => setSortOrder('DESC')}
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className='col-6 col-md-2 dropdown'>
              <button
                className='btn btn-export dropdown-toggle'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                <svg
                  width='17'
                  height='17'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M9 11V17L11 15'
                    stroke='#868484'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M9 17L7 15'
                    stroke='#868484'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14'
                    stroke='#868484'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M22 10H18C15 10 14 9 14 6V2L22 10Z'
                    stroke='#868484'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>{' '}
                Export
              </button>

              <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                <li className='dropdown-item' onClick={() => exportExperienceCenters('text/csv')}>
                  Export as .csv
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='card-body border-0 px-3'>
          <div className='table-responsive'>
            <table className='table'>
              <thead>
                <tr>
                  <td>S/N</td>
                  <td>C. Name</td>
                  <td>C. MSISDN</td>
                  <td>Station Name</td>
                  <td>Station Address</td>
                  <td>Status</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {centers &&
                  centers.map((center: experienceCenterType, index: Key) => (
                    <tr key={index}>
                      <td>{Number(index) + 1}</td>
                      <td>
                        {center.customer.firstName} {center.customer.lastName}
                      </td>{' '}
                      <td>{center.customer.msisdn}</td>
                      <td>{center.stationName}</td>
                      <td>{center.stationAddress}</td>
                      <td>
                        <span
                          className={
                            ['REJECTED', 'PENDING_APPROVAL'].includes(
                              String(center?.approvalStatus),
                            ) === true
                              ? 'pending'
                              : 'approve'
                          }
                        >
                          {center.approvalStatus
                            .replace(/_/g, ' ')
                            .toLowerCase()
                            .replace(/\b\w/g, (ch) => ch.toUpperCase())}
                        </span>
                      </td>
                      <td>
                        <Link to={`/tgplus-subscription/experience-center/${center.id}`}>
                          <button className='btn btn-view'>View</button>
                        </Link>

                        <button
                          className='btn border-0 dropdown-toggle'
                          data-bs-toggle='dropdown'
                          aria-expanded='false'
                          data-bs-popper-config='{"strategy":"fixed"}'
                        >
                          <svg
                            width='18'
                            height='18'
                            viewBox='0 0 18 18'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7.49991 8.47001C7.49991 7.72884 8.0955 7.14649 8.82344 7.14649C9.55139 7.14649 10.147 7.74207 10.147 8.47001C10.147 9.19796 9.55139 9.79354 8.82344 9.79354C8.0955 9.79354 7.49991 9.21119 7.49991 8.47001Z'
                              fill='#707070'
                            />
                            <path
                              d='M7.49991 14.1185C7.49991 13.3773 8.0955 12.7949 8.82344 12.7949C9.55139 12.7949 10.147 13.3905 10.147 14.1185C10.147 14.8464 9.55139 15.442 8.82344 15.442C8.0955 15.442 7.49991 14.8596 7.49991 14.1185Z'
                              fill='#707070'
                            />
                            <path
                              d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55139 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55139 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                              fill='#707070'
                            />
                          </svg>
                        </button>

                        <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                          <Link
                            to={`/tgplus-subscription/experience-center/${center.id}`}
                            className='text-dark'
                          >
                            <li className='dropdown-item'>View</li>{' '}
                          </Link>
                          <li
                            className='dropdown-item'
                            onClick={() => toggleAprovalModal(center.id)}
                          >
                            <Link to={'#'} className='text-dark'>
                              Approve
                            </Link>{' '}
                          </li>
                          <li className='dropdown-item' onClick={() => toggleModal(center.id)}>
                            <Link to={'#'} className='text-dark'>
                              Reject
                            </Link>{' '}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {pageTotal >= pageSize && (
        <div className='pagination w-100 d-flex justify-content-center'>
          {pageTotal && (
            <Pagination
              className='pagination-bar ps-0'
              currentPage={Number(page)}
              totalCount={pageTotal}
              pageSize={pageSize}
              onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
            />
          )}
        </div>
      )}

      <ModalWrapper
        showModal={showModal}
        closeModal={() => toggleModal(ID)}
        title='Reject Application'
      >
        <form className='rejection-form'>
          <div className='form-group'>
            <label htmlFor=''>Reason for Rejection</label>
            <textarea
              className='form-control'
              required={true}
              onChange={(e: { target: { value: string } }) => serRejectionReason(e.target.value)}
            />
          </div>

          <div className='form-group mt-3'>
            <button
              type='button'
              className='btn btn-default btn-reject-001 w-100'
              onClick={reject}
              disabled={rejectionRequest}
            >
              {rejectionRequest && <span className='spinner-border spinner-border-sm'></span>}{' '}
              Submit
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        showModal={showApprovalModal}
        closeModal={() => toggleAprovalModal(ID)}
        title='Approve Application'
      >
        <form className='rejection-form'>
          <div className='form-group'>
            <label htmlFor=''>Comment</label>
            <textarea
              required={true}
              className='form-control'
              onChange={(e: { target: { value: string } }) => serApprovalReason(e.target.value)}
            />
          </div>

          <div className='form-group mt-3'>
            <button
              type='button'
              className='btn btn-default btn-reject-001 w-100'
              onClick={approve}
              disabled={approvalRequest}
            >
              {approvalRequest && <span className='spinner-border spinner-border-sm'></span>} Submit
            </button>
          </div>
        </form>
      </ModalWrapper>
    </div>
  )
}

export default ExperienceCenter
